import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeletePlanReviewCategoryMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeletePlanReviewCategoryMutation = { __typename?: 'mutation_root', delete_plan_review_categories_by_pk?: { __typename?: 'plan_review_categories', id: any } | null };


export const DeletePlanReviewCategoryDocument = gql`
    mutation deletePlanReviewCategory($id: uuid!) {
  delete_plan_review_categories_by_pk(id: $id) {
    id
  }
}
    `;
export type DeletePlanReviewCategoryMutationFn = Apollo.MutationFunction<DeletePlanReviewCategoryMutation, DeletePlanReviewCategoryMutationVariables>;

/**
 * __useDeletePlanReviewCategoryMutation__
 *
 * To run a mutation, you first call `useDeletePlanReviewCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlanReviewCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlanReviewCategoryMutation, { data, loading, error }] = useDeletePlanReviewCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlanReviewCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlanReviewCategoryMutation, DeletePlanReviewCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlanReviewCategoryMutation, DeletePlanReviewCategoryMutationVariables>(DeletePlanReviewCategoryDocument, options);
      }
export type DeletePlanReviewCategoryMutationHookResult = ReturnType<typeof useDeletePlanReviewCategoryMutation>;
export type DeletePlanReviewCategoryMutationResult = Apollo.MutationResult<DeletePlanReviewCategoryMutation>;
export type DeletePlanReviewCategoryMutationOptions = Apollo.BaseMutationOptions<DeletePlanReviewCategoryMutation, DeletePlanReviewCategoryMutationVariables>;